export default __webpack_public_path__ + "static/media/handover-waiting.dbc6e14e.svg";